import React, { Fragment } from "react";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const RecentSupporters = ({ supporter }) => {
  return (
    <Fragment>
      <div
        className={`online-user ${
          supporter && supporter.role === "innovator"
            ? "green"
            : supporter && supporter.role === "mentor"
            ? "red"
            : supporter && supporter.role === "employer"
            ? "blue"
            : ""
        }`}
      >
        <div className="flex-only">
          <div className="online-avi-container">
            <div
              className={`avi-color-border ${
                supporter && supporter.role === "innovator"
                  ? "green"
                  : supporter && supporter.role === "mentor"
                  ? "red"
                  : supporter && supporter.role === "employer"
                  ? "blue"
                  : ""
              }`}
            >
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${supporter.avatar}`}
                className="drop-down-result-avi"
              />
            </div>
          </div>
          <div className="online-info">
            <ul className="user-online-items">
              <li className="user-online-item">
                <span
                  className={`${
                    supporter && supporter.role === "innovator"
                      ? "green"
                      : supporter && supporter.role === "mentor"
                      ? "red"
                      : supporter && supporter.role === "employer"
                      ? "blue"
                      : ""
                  } name-font`}
                >
                  {supporter.channelid}
                </span>
              </li>
              <li className="side-container-user-item">
                {supporter.firstname} {supporter.lastname}
              </li>
              <li className="side-container-user-item">
                {formatter.format(supporter.amount)}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RecentSupporters;
